export const ADD_TO_BASKET = "ADD_TO_BASKET";
export const REMOVE_FROM_BASKET = "REMOVE_FROM_BASKET";
export const SIGN_UP_USER = "SIGN_UP_USER";
export const RESET_USER = "RESET_USER";
export const ADD_SHIPPING_ADDRESS = "ADD_SHIPPING_ADDRESS";
export const ADD_PAYMENT_METHOD = "ADD_PAYMENT_METHOD";
export const ADD_ORDERS = "ADD_ORDERS";
export const RESET_STORAGE = "RESET_STORAGE";
export const UPDATE_PAYMENT = "UPDATE_PAYMENT";
